module.exports = __webpack_public_path__ + "assets/img/1_1715_big.0bb3be2f.jpg";